import axios from 'axios';
import SignupTenantService from '../../services/SignupTenantService'

export function saveTenant(state, payload) {
    return new Promise((resolve, reject) => {
        SignupTenantService.saveTenant(payload)
            .then(response => {
                resolve(response.data)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export function loadCep({ getters, commit }, zipCode) {
    return new Promise((resolve, reject) => {
        const _zipCode = zipCode.trim().replace(/[^0-9]/g, '');

        const url_cep = 'https://viacep.com.br/ws/' + _zipCode + '/json';

        // clear all headers axios to viacep
        axios.defaults.headers.common = null;

        axios.get(url_cep).then(function (response) {
            commit('setAddress', {
                zipCode: zipCode,
                patio: response.data.logradouro,
                neighborhood: response.data.bairro,
                state: response.data.uf,
                city: response.data.localidade,
                ibge: response.data.ibge,
                ddd: response.data.ddd
            })

            resolve()

        }.bind(this)).catch(function (error) {
            commit('setAddress', null)
            console.error(error);
            reject(error)
        });
    })
}
